import React from 'react';
import './App.scss';
import './requirement/requirement.scss'
import Home from './home/home'
import Header from './header'

function App() {
    return (
        <div className="App">
            <Header/>
            <Home/>
        </div>
    );
}

export default App;
